import React, { useState } from "react";

const DEFAULT_AVATAR =
  "https://ui-avatars.com/api/?name=Admin+User&background=1F3A60&color=fff";

const Avatar = ({
  src,
  alt,
  size = 40,
  className = "",
  ring = false,
}) => {
  const [imgSrc, setImgSrc] = useState(src || DEFAULT_AVATAR);

  return (
    <div
      className={`rounded-full overflow-hidden flex-shrink-0 ${
        ring ? "border-2 border-white" : ""
      } ${className}`}
      style={{
        width: size,
        height: size,
      }}
    >
      <img
        src={imgSrc}
        alt={alt}
        onError={() => setImgSrc(DEFAULT_AVATAR)}
        className="w-full h-full object-cover rounded-full"
      />
    </div>
  );
};

export default Avatar;